const { encodeHTMLEntities, processText } = require("../helpers");
const removeMd = require('remove-markdown');
const { getImageUrl } = require("../image-helper");

module.exports = (props) => {
  const { images } = props.value;

  // Max dimensions based off legacy slideshows
  const maxWidth = 775;
  const maxHeight = 515;

  const slideshowImage = (image, fullImageUrl) => {
    const captionHtml = (image.caption || [])
      .map(block => encodeHTMLEntities(removeMd(processText(null, [block]))))
      .join('<br/><br/>');
    const descriptionHtml = (image.description || [])
      .map(block => encodeHTMLEntities(removeMd(processText(null, [block]))))
      .join('<br/><br/>');
    const titleHtml = processText(image.title || "");

    const imageAltText = image.altText ? 
      (image.altText || []).map(block => encodeHTMLEntities(removeMd(processText(null, [block])))).join(' ') : 
      captionHtml;

    const creditHtml = `
      <div class='typography $typography/weight:bold $typography/size:large' style='padding: 0.25rem 0.5rem'>
        <h3><em>${encodeHTMLEntities(titleHtml)}</em></h3>
      </div>
      <br/>
      <br/>
      <div>${descriptionHtml}</div>
      <br/>
      <div class='overlay__caption__text'>${encodeHTMLEntities(removeMd(captionHtml))}</div>
      <br/>
      <br/>
      `;

    return `
    <picture class="
      picture
      ">
      <img
        class="
          link/enable
          link/focus
          picture/image
          layout/height:auto
        "
        src="${fullImageUrl}"
        alt="${encodeHTMLEntities(removeMd(imageAltText))}"
        draggable="false"
        oncontextmenu="return false;"
        role="button"
        loading="lazy"
        data-image-overlay-title="${encodeHTMLEntities(removeMd(props.value.title))}"
        data-image-overlay-credit="${creditHtml}"
        data-image-overlay-item=""
        data-image-overlay-src="${fullImageUrl}"
        data-image-overlay-slideshow-item=""
        tabindex="0"
        ontouchstart=""
        onerror="window.MoMA.onImageError(this, 1)"
      />
    </picture>
  `
  };

  const slideshow = `
    <div class="content-promo__image-container" style="max-width: ${maxWidth}px;">
      <div class="content-promo__overlay" style="pointer-events: none; z-index: 2;">
        <svg xmlns="http://www.w3.org/2000/svg" class="content-promo__overlay__svg" width="24" height="24"> <path d="M15 16V9H8V8h8v8h-1zm2-2V7h-7V6h8v8h-1zM6 10h8v8H6v-8z"></path></svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="content-promo__overlay__svg--nonmobile" width="32" height="32"> <path d="M19.5 21v-8.5H11V11h10v10h-1.5zm3-3V9.5H14V8h10v10h-1.5zM8 14h10v10H8V14z"></path></svg>
      </div>
      <div class="ratio-container">
        <div class="ratio-container__3-2">
        </div>
        <div class="ratio-container__inner">
          <div class="content-promo__overlay" style="pointer-events: none; z-index: 2;">
            <svg xmlns="http://www.w3.org/2000/svg" class="content-promo__overlay__svg" width="24" height="24"> <path d="M15 16V9H8V8h8v8h-1zm2-2V7h-7V6h8v8h-1zM6 10h8v8H6v-8z"></path></svg>
            <svg xmlns="http://www.w3.org/2000/svg" class="content-promo__overlay__svg--nonmobile" width="32" height="32"> <path d="M19.5 21v-8.5H11V11h10v10h-1.5zm3-3V9.5H14V8h10v10h-1.5zM8 14h10v10H8V14z"></path></svg>
          </div>
          ${slideshowImage(props.value.thumbnailImage, getImageUrl(props.value.thumbnailImage, { width: maxWidth, height: maxHeight }) )}
        </div>
      </div>
    </div>
    <div class="hidden-images" style="display: none;">
      ${images.map(image => slideshowImage(image, getImageUrl(image.image))).join('')}
    </div>
    <h3 style="margin-top: 0;">
      <span class="content-promo__title__text balance-text">${processText(props.value.title || "")}</span>
    </h3>
    <span class="content-promo__count-date__text">${props.value.images.length} images</span>
  `;

  return slideshow;
};
